module.exports = __webpack_public_path__ + "img/ElCamino.07993a53.jpeg";